import * as React from 'react';
import { Text } from '@react-pdf/renderer';
import { getStyle } from './DatanauswertungGenerischStyles';

export function parsePdfSub2(str: any, style?: any): any {
    if (Array.isArray(str)) {
        return str.map((s: any) => parsePdfSub2(s, style));
    } else if (typeof str !== 'string') {
        return str;
    }
    const ar = str.split('₂');
    const comp: Array<JSX.Element> = [];
    let sty = style && style.fontSize ? { fontSize: getScaledAttr(style.fontSize, 0.6) } : {};
    sty = { ...getStyle('sub'), ...sty };
    // console.log(style, sty);
    ar.forEach((s: string, i: number) => {
        comp.push(<Text key={`s-${i}`}>{s}</Text>);
        if (i < ar.length - 1) {
            comp.push(<Text key={`sub-${i}`} style={sty}>2</Text>);
        }
    });
    return comp;
}

export function getScaledAttr(value: string, scale: number) {
    if (typeof value === 'string') {
        const val = parseInt(value, 10);
        const unit = value.replace(/[0-9]/g, '');
        return Math.round(val * scale) + unit;
    }
    return value;
}

export function compareObjects(a: any, b: any): boolean {
    if (a === b) {
        // console.log('COMPARE 1: SAME: ', a,  b);
        return true;
    }
    if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) {
        // console.log('COMPARE 2: MISS: ', a,  b);
        return false;
    }
    const keysA = Object.keys(a), keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
        // console.log('COMPARE 3: MISS: ', a,  b);
        return false;
    }
    let result = true;
    keysA.forEach((key: string) => {
        if (!b.hasOwnProperty(key)) {
            // console.log('COMPARE 4: MISS: ', a,  b);
            result = false;
        }
        if (typeof a[key] === 'function' || typeof b[key] === 'function') {
            if (a[key].toString() !== b[key].toString()) {
                //  console.log('COMPARE 5: MISS: ', a,  b);
                result = false;
            }
        } else {
            if (!compareObjects(a[key], b[key])) {
                //  console.log('COMPARE 6: MISS: ', a,  b);
                result = false;
            }
        }
    });
    // console.log('COMPARE F: SAME: ', a,  b);
    return result;
}
